import { Component , signal, ChangeDetectorRef, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { Router } from '@angular/router';
import { FullCalendarModule } from '@fullcalendar/angular';
import { CalendarOptions, DateSelectArg, EventClickArg, EventApi } from '@fullcalendar/core';
import interactionPlugin from '@fullcalendar/interaction';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import { INITIAL_EVENTS, createEventId } from './event-utils';
import itLocale from '@fullcalendar/core/locales/it';
import { CommonService } from '../service/common.service';
import { Evento } from '../models/evento';
import { Azienda } from '../models/azienda';
import { AddeventoComponent } from '../dialog/addevento/addevento.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-calendario',
  templateUrl: './calendario.component.html',
  styleUrls: ['./calendario.component.css']
})
export class CalendarioComponent implements OnInit{
  calendarVisible = signal(true);
  calendarPlugins = [dayGridPlugin];
  aziende: Azienda[];


calendarEvents = [

{ title: 'Evento 1', date: '2025-01-24' },

{ title: 'Evento 2', date: '2025-01-25' }

];

calendarOptions = signal<CalendarOptions>({
   plugins: [
     interactionPlugin,
     dayGridPlugin,
     timeGridPlugin,
     listPlugin,
   ],
   headerToolbar: {
     left: 'prev,next today',
     center: 'title',
     right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek'
   },
   initialView: 'dayGridMonth',
  // initialEvents: INITIAL_EVENTS, // alternatively, use the `events` setting to fetch from a feed
   locales: [ itLocale ],
   weekends: true,
   editable: true,
   selectable: true,
   selectMirror: true,
   dayMaxEvents: true,
   events: this.commonService.eventipercalendario,
//    events: [ { title: 'Appuntamento 1', start: '2025-01-01T14:30:00', end: '2025-01-01T15:30:00' }, { title: 'Appuntamento 2', date: '2025-01-15' } ],

   locale:"it",
   select: this.handleDateSelect.bind(this),
   eventClick: this.handleEventClick.bind(this),
   eventsSet: this.handleEvents.bind(this)
   /* you can update a remote database when these fire:
   eventAdd:
   eventChange:
   eventRemove:
   */
 });
 currentEvents = signal<EventApi[]>([]);
 ngOnInit() {

}
 constructor(private changeDetector: ChangeDetectorRef, private router: Router, private commonService: CommonService, private dialog: MatDialog) {

}

 handleCalendarToggle() {
    this.calendarVisible.update((bool) => !bool);
  }

  handleWeekendsToggle() {
    this.calendarOptions.update((options) => ({
      ...options,
      weekends: !options.weekends,
    }));
  }

  handleDateSelect(selectInfo: DateSelectArg) {
/*
    this.commonService.getAllAziendeByTiporelazione(2).subscribe(response => {
          this.aziende=response;
          this.showDialogEvento(selectInfo, undefined, '0');
    });
*/
    this.showDialogEvento(selectInfo, undefined, '0');
//    const title = prompt('Inserisci il nome evento');

  }

  showDialogEvento(selectInfo: DateSelectArg, evento: Evento, codiceeventoazienda: string){
    let title='';
    let starttime='';
    let endtime='';
    let codiceazienda=0;
    let nomeazienda=0;
    let tipoevento='';
    let azienda: Azienda=new Azienda();
    let eid=codiceeventoazienda;

    if (evento!=undefined){
      starttime=evento.Timeinizio;
      endtime=evento.Timefine;
      title=evento.Titolo;
    }


    const dialogRef = this.dialog.open(AddeventoComponent, {
       width: '1024px',
       maxHeight: '600px',
       data: {aziende: this.aziende}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result){
  //      codiceazienda=result['codiceazienda'];
  //      nomeazienda=result['nomeazienda'];
        tipoevento=result['tipoevento'];
        azienda=result['azienda'];
        title=result['titolo']+' ('+azienda.Nome+')'+' ('+tipoevento+')';
        starttime=result['orainizio'];
        endtime=result['orafine'];

  //      eid=createEventId();
        console.log(eid);
        const calendarApi = selectInfo.view.calendar;

        let evento:Evento=new Evento();

        evento.Datainizio=selectInfo.startStr;
        evento.Datafine=selectInfo.startStr;
        evento.Timeinizio=starttime;
        evento.Timefine=endtime;
        evento.Titolo=title;
        evento.Tipoevento=tipoevento;
      //  evento.Codiceazienda=codiceazienda;
        evento.Codiceazienda=azienda.Codice;

        this.commonService.saveEvento(evento).subscribe(rc => {

          if (rc>0){
            calendarApi.addEvent({
              id: rc.toString(),
              title,
            //      start: '2025-02-01T14:30:00',
            //      end: '2025-02-01T16:30:00',
              start: selectInfo.startStr+'T'+starttime,
              end: selectInfo.startStr+'T'+endtime,
            //      allDay: selectInfo.allDay
              allDay: false
            });
            /*
            this.commonService.saveEventoazienda(rc, codiceazienda).subscribe(rc2 => {
              if (rc2>0){
                calendarApi.addEvent({
                  id: rc2.toString(),
                  title,
                //      start: '2025-02-01T14:30:00',
                //      end: '2025-02-01T16:30:00',
                  start: selectInfo.startStr+'T'+starttime,
                  end: selectInfo.startStr+'T'+endtime,
                //      allDay: selectInfo.allDay
                  allDay: false
                });
              }else{
                console.log("Errore salvataggio cliente appuntamento");
              }
            });
            */
            this.commonService.saveAzienda(azienda).subscribe(rc2 => {
              if (Number(rc2)<0){
                alert("Errore aggiornamento email azienda");
              }
            });
          }else{
            console.log("Errore salvataggio appuntamento");
          }
        });

        calendarApi.unselect(); // clear date selection

      }
     });
  }
  handleEventClick(clickInfo: EventClickArg) {
  /*
      let codiceeventoazienda:string=clickInfo.event._def.publicId;
      console.log("---->"+codiceeventoazienda);
      this.commonService.getEventoByCodiceEventiazienda(codiceeventoazienda).subscribe(evento => {
        console.log("--->"+evento);
        this.showDialogEvento(undefined, evento, codiceeventoazienda);
      });

   let codiceeventoazienda:string=clickInfo.event._def.defId;

  }
*/
//  deleteEventoazienda(clickInfo: EventClickArg){

  const calendarApi = clickInfo.view.calendar;

  let codiceevento:string=clickInfo.event._def.publicId;

  if (confirm(`Conferma cancellazione? '${clickInfo.event.title}'`)) {
      clickInfo.event.remove();
      this.commonService.deleteEvento(codiceevento).subscribe(rc => {
        if (rc<=0){
          console.log("Errore cancellazione appuntamento");
        }
      });
    }

  }

  handleEvents(events: EventApi[]) {
    this.currentEvents.set(events);
    this.changeDetector.detectChanges(); // workaround for pressionChangedAfterItHasBeenCheckedError
  }

}
